import { StatisticsOnlyFansView } from '@/modules/statistics/onlyfans/views/StatisticsOnlyFansView'

export const StatisticsOnlyFansPage = () => {
  return <StatisticsOnlyFansView />
}
